var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.7577 32 32 24.7577 32 16C32 7.22632 24.7577 0 15.984 0C7.22632 0 0 7.22632 0 16C0 24.7577 7.24227 32 16 32ZM10.321 22.7159C9.76271 22.7159 9.3001 22.2692 9.3001 21.6949C9.3001 21.4078 9.39581 21.1685 9.60319 20.9611L14.5484 16.016L9.60319 11.0708C9.39581 10.8634 9.3001 10.6241 9.3001 10.337C9.3001 9.77866 9.76271 9.332 10.321 9.332C10.6241 9.332 10.8475 9.42772 11.0548 9.65105L16 14.5803L20.9611 9.63509C21.1844 9.41176 21.4237 9.31605 21.6949 9.31605C22.2692 9.31605 22.7318 9.76271 22.7318 10.321C22.7318 10.6082 22.6361 10.8315 22.4128 11.0708L17.4676 16.016L22.4128 20.9452C22.6042 21.1685 22.7159 21.4078 22.7159 21.6949C22.7159 22.2692 22.2532 22.7159 21.679 22.7159C21.3918 22.7159 21.1366 22.6042 20.9292 22.3968L16 17.4676L11.0867 22.3968C10.8794 22.6201 10.6241 22.7159 10.321 22.7159Z",
    fill: "#282829",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.1cd649611b5439662a97963ccb4a42d7.svg";
export { ForwardRef as ReactComponent };